import RequestStatus from "../model/RequestStatus";
import {GetProductDataResponse} from "../model/ProductMatch";
import {
    PRODUCT_DATA_QUERY_FAILED,
    PRODUCT_DATA_QUERY_START,
    PRODUCT_DATA_QUERY_SUCCESS,
    GetProductDataQueryComplete
} from "../actions/ProductSearchAction";

const initialState: GetProductDataResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    productData: null,
};

export default (
    state: GetProductDataResponse = initialState,
    action: GetProductDataQueryComplete
): GetProductDataResponse => {
    switch (action.type) {
        case PRODUCT_DATA_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                productData: null,
            };
        case PRODUCT_DATA_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                productData: action.productData,
            };
        case PRODUCT_DATA_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                productData: null,
            };
        default:
            return state;
    }
};

